import { render, staticRenderFns } from "./phoneBooks_img.vue?vue&type=template&id=8619a716&scoped=true&"
import script from "./phoneBooks_img.vue?vue&type=script&lang=js&"
export * from "./phoneBooks_img.vue?vue&type=script&lang=js&"
import style0 from "./phoneBooks_img.vue?vue&type=style&index=0&id=8619a716&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8619a716",
  null
  
)

export default component.exports